import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import get from 'lodash/get'
import { status as Status } from '@bt-react/constants'

/**
 * Determines whether the current webcast has compeleted or not
 * @param state The Redux state
 */

const getWebcastStatus = (state: State): string => {

  const collectionId = `${state.config.channelId}${state.config.webcastId}`
  return get(state.webcast, `collection.${collectionId}.data.status`, '')

}
const getIsTerminated = (state: State): boolean => state.ui.isTerminated
const getBookingStatus = (state: State): Status | null => state.ui.status

export default createSelector(
  [getWebcastStatus, getIsTerminated, getBookingStatus],
  (webcastStatus, isTerminated, bookingStatus) => {

    return webcastStatus === 'processing' ||
      webcastStatus === 'recorded' ||
      isTerminated ||
      bookingStatus === Status.COMPLETE ||
      bookingStatus === Status.POST_ROLL_INTERSTITIAL

  })
